import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { Grid } from "@material-ui/core"
import './validation-code.css'


function ValidationCodePure(props) {
    const {
        data,
        setData,
        validationLength,
        title,
        hide,
        autoFocusNIP,
        handleValidateNip,
        cleanInputsRef
    } = props
    const { t } = useTranslation()
    const input = React.createRef();
    const [focused, setFocused] = useState(false);
    const [validationCode, setValidationCode] = useState('');


    const CODE_LENGTH = new Array(validationLength).fill(0)
    const validationCodes = validationCode.split("")

    const hideInput = !(validationCodes.length < CODE_LENGTH.length)

    const selectedIndex = (validationCodes.length < CODE_LENGTH.length) ? validationCodes.length : CODE_LENGTH.length - 1

    const inputValues = [-2, 30, 63, 96];

    const getLeftValue = (index) => inputValues[index] ?? index * 32;

    useEffect(() => {
        if (data.length !== 4 || !handleValidateNip) return
        handleValidateNip(handleCleanInputs)
    }, [data])

    const handleFocus = () => {
        setFocused(true)
    };

    const handleBlur = () => {
        setFocused(false)
    };

    const handleChange = (e) => {
        const value = e.target.value.slice(0, validationLength);

        const CODE_LENGTH = new Array(validationLength).fill(0);

        if (validationCode.length >= CODE_LENGTH.length) return null;


        let code
        let realcode = data + value
        if (hide) {
            code = validationCode + '*'
        } else {
            code = validationCode + value
        }

        code.slice(0, CODE_LENGTH.length)
        realcode.slice(0, CODE_LENGTH.length)
        setValidationCode(code)
        setData(realcode)
    };

    const handleKeyUp = (e) => {
        if (e.key === "Backspace") {
            let code = validationCode.slice(0, validationCode.length - 1)
            let realcode = data.slice(0, data.length - 1)
            setValidationCode(code)
            setData(realcode)
        }
    };

    const handleClick = () => {
        input.current.focus();
    };

    const handleCleanInputs = () => {
        setValidationCode('')
        setData('')
    }

    useEffect(() => {
        if (cleanInputsRef) {
            cleanInputsRef.current = handleCleanInputs
        }
    }, [cleanInputsRef])

    return (
        <Grid className='validation-code-container-code'>
            <label className='validation-code-form-inputs-labels'>{title}</label>
            <div className="validation-code-wrap" onClick={handleClick}>
                <input
                    autoFocus={autoFocusNIP}
                    value=""
                    ref={input}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onKeyUp={handleKeyUp}
                    className="validation-code-input"
                    style={{
                        width: "32px",
                        top: "0px",
                        bottom: "0px",
                        left: `${getLeftValue(selectedIndex)}px`,
                        opacity: hideInput ? 0 : 1,
                    }}
                />
                {CODE_LENGTH.map((v, index) => {
                    const selected = validationCodes.length === index
                    const filled =
                        validationCodes.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1

                    return (
                        <div className="validation-code-display">
                            {validationCodes[index]}
                            {(selected || filled) && focused && <div className="validation-code-shadows" />}
                        </div>
                    )
                })}
            </div>
        </Grid>
    )
}

export { ValidationCodePure as default }
